import { FC } from "react";
import { Box, Stack, Card, Typography } from "@mui/material";
import { RevenueChart } from "../../CustomChart/RevenueChart";
import { ChartlistProps } from "../types";

type Revenue = {
  label: string;
  value: number;
};

export const RevenueList: FC<ChartlistProps<Revenue>> = ({ label, items }) => {
  return (
    <Box>
      <Stack spacing={2} direction="row">
        {items &&
          items.map((revenue, index) => {
            return (
              <Card
                sx={{
                  width: "100%",
                  maxWidth: 700,
                  minWidth: 140,
                  height: 165,
                  borderRadius: 2,
                }}
              >
                <RevenueChart
                  key={index}
                  label={revenue.label}
                  value={revenue.value}
                />
              </Card>
            );
          })}
      </Stack>
    </Box>
  );
};
